import { createContext } from 'react';

type TooltipMode = 'ipo' | 'e-tjanster';

export const TooltipModeContext = createContext<TooltipMode | undefined>(undefined);
